<template>
	<div class="flex items-center ml-4 mt-4 md:ml-0 md:mt-0">
		<button
			@click="showDropdown = !showDropdown"
			class="
				text-gray-700 text-2xl
				outline-none
				focus:outline-none
				flex
				items-center
			"
		>
			<RoundImage
				heightWeight="w-8 h-8 md:w-8 md:h-8"
				imageStyle="shadow-md rounded-full border-2 border-gray-100"
				:image="user?.profile?.photo"
			/>

        <div class="flex flex-col justify-items-start items-start mx-2">
            <p class="text-xs px-1 text-gray-600 font-bold">{{ user?.name.split(" ")[0] }}</p>
            <p class="text-xs px-1 text-gray-400">{{ user?.phone }}</p>
        </div>
			<svg
				:class="[showDropdown ? 'opened' : 'closed']"
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
				class="feather feather-chevron-down"
			>
				<polyline points="6 9 12 15 18 9"></polyline>
			</svg>
		</button>

		<div
			class="
				md:hidden
				origin-top-right
				top-14
				left-3
				md:top-10 md:left-auto
				absolute
				z-50
				md:right-0
				mt-2
				w-56
				rounded-md
				shadow-lg
				bg-white
				ring-1 ring-black ring-opacity-5
			"
		>
			<div
				class="py-1"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="options-menu"
			>
				<p
					class="cursor-pointer block capitalize px-4 py-2 hover:bg-gray-100"
					@click="
						logOut();
						$emit('onClickAccountDropdown');
					"
				>
					<span
						class="text-sm text-gray-700 hover:text-gray-900"
						v-if="!isLoggingOut"
						>Log Out</span
					>
					<span class="text-sm text-gray-700 hover:text-gray-900" v-else
						>Logging Out</span
					>
				</p>
			</div>
		</div>

		<div
			v-if="showDropdown"
			class="
				hidden
				md:block
				origin-top-right
				top-14
				left-3
				md:top-10 md:left-auto
				absolute
				z-50
				md:right-0
				mt-2
				w-56
				rounded-md
				shadow-lg
				bg-white
				ring-1 ring-black ring-opacity-5
			"
		>
			<div
				class="py-1"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="options-menu"
			>
        <!--<template v-for="(item, i) in links">
					<router-link
					    :to="{name: item.link}"
						:key="i"
						@click="
							nevigate();
							$emit('onClickAccountDropdown');
						"
						v-if="userType === item.type"
						class="cursor-pointer block capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
					>
						{{ item.title }}
					</router-link>
				</template>-->

          <div
              @click="$router.push('/provider/profile'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44444 7.55556C8.44444 6.61256 8.81905 5.70819 9.48584 5.0414C10.1526 4.3746 11.057 4 12 4C12.943 4 13.8474 4.3746 14.5142 5.0414C15.181 5.70819 15.5556 6.61256 15.5556 7.55556C15.5556 8.49855 15.181 9.40292 14.5142 10.0697C13.8474 10.7365 12.943 11.1111 12 11.1111C11.057 11.1111 10.1526 10.7365 9.48584 10.0697C8.81905 9.40292 8.44444 8.49855 8.44444 7.55556ZM8.44444 12.8889C7.2657 12.8889 6.13524 13.3571 5.30175 14.1906C4.46825 15.0241 4 16.1546 4 17.3333C4 18.0406 4.28095 18.7189 4.78105 19.219C5.28115 19.719 5.95942 20 6.66667 20H17.3333C18.0406 20 18.7189 19.719 19.219 19.219C19.719 18.7189 20 18.0406 20 17.3333C20 16.1546 19.5317 15.0241 18.6983 14.1906C17.8648 13.3571 16.7343 12.8889 15.5556 12.8889H8.44444Z" fill="#1A1A1A"/>
              </svg>
              <span class="ml-2">প্রোফাইল</span>
          </div>

          <div
              @click="$router.push('/my-wallet'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7.21606 5.4264L14.4083 3.38597L14.0274 2.5858C13.7782 2.06569 13.1704 1.85091 12.67 2.10991L6.23144 5.4264H7.21606ZM16.6409 3.44493C16.5518 3.44493 16.4626 3.45756 16.3735 3.48283L14.6838 3.96293L9.52365 5.4264H17.9335L17.6174 4.22193C17.4959 3.75236 17.0866 3.44493 16.6409 3.44493ZM18.989 6.1634H4.01502C3.69491 6.1634 3.40925 6.31711 3.22286 6.55927C3.13777 6.67087 3.07294 6.79932 3.03647 6.9404C3.01418 7.02884 3 7.12149 3 7.21625V18.9471C3 19.5283 3.45382 20 4.01299 20H18.987C19.5462 20 20 19.5283 20 18.9471V16.0097H13.9889C13.0387 16.0097 12.2668 15.2074 12.2668 14.2198V11.8783C12.2668 11.394 12.4532 10.9539 12.7551 10.6317C13.0225 10.3453 13.3811 10.1516 13.7823 10.1032C13.8491 10.0948 13.918 10.0905 13.9869 10.0905H20V7.21625C20.002 6.63507 19.5482 6.1634 18.989 6.1634Z" fill="#1A1A1A"/>
                  <path d="M20.6724 11.248C20.572 11.1609 20.4534 11.0946 20.3208 11.0511C20.2183 11.0189 20.1098 11 19.9952 11H14.0048C13.4501 11 13 11.424 13 11.9465V14.0535C13 14.576 13.4501 15 14.0048 15H19.9952C20.1098 15 20.2183 14.9811 20.3208 14.9489C20.4534 14.9072 20.572 14.8391 20.6724 14.752C20.8734 14.5797 21 14.3299 21 14.0535V11.9465C21 11.6701 20.8734 11.4202 20.6724 11.248ZM16.1027 13.1883C16.1027 13.4496 15.8777 13.6616 15.6004 13.6616H15.2668C14.9895 13.6616 14.7644 13.4496 14.7644 13.1883V12.8741C14.7644 12.7227 14.8387 12.5882 14.9573 12.503C15.0437 12.4406 15.1502 12.4008 15.2668 12.4008H15.6004C15.8777 12.4008 16.1027 12.6128 16.1027 12.8741V13.1883Z" fill="#1A1A1A"/>
              </svg>
              <span class="ml-2">পেমেন্ট</span>
          </div>

          <div
              @click="$router.push('/provider/car/index'); nevigate(); $emit('onClickAccountDropdown');"
              class="items-center cursor-pointer flex capitalize px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-b-1 border-gray-100"
          >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20.2606 9.83112C20.2479 9.81691 20.2371 9.80306 20.2221 9.78922L19.5613 9.16922C20.1093 9.04836 20.6993 8.60198 20.6993 8.14399C20.6993 7.61043 19.9377 7.4211 19.2876 7.4211C18.608 7.4211 18.5291 7.87384 18.521 8.19376L16.816 6.59568C16.4696 6.26229 15.8126 6 15.3215 6H8.67867C8.18796 6 7.53137 6.26229 7.1846 6.59568L5.48 8.19376C5.47115 7.87384 5.39225 7.4211 4.71334 7.4211C4.06252 7.4211 3.30125 7.61043 3.30125 8.14399C3.30125 8.60198 3.89164 9.04836 4.4397 9.16922L3.77887 9.78922C3.76386 9.80306 3.75347 9.81691 3.74039 9.83112C3.03338 10.4186 2.57153 11.5082 2.57153 12.2988V14.6482C2.57153 15.2184 2.80284 15.7359 3.17655 16.1217V17.0328C3.17655 17.5656 3.63532 18 4.19954 18H5.43651C6.00073 18 6.45912 17.5663 6.45912 17.0328V16.7997H17.5415V17.0328C17.5415 17.5663 17.9995 18 18.5645 18H19.8011C20.3657 18 20.8237 17.5656 20.8237 17.0328V16.1217C21.212 15.7239 21.4285 15.1965 21.4287 14.6482V12.2988C21.4294 11.5082 20.9676 10.4186 20.2606 9.83112ZM7.81078 7.30585C8.05056 7.11166 8.46968 6.96424 8.67867 6.96424H15.3223C15.5313 6.96424 15.9504 7.11166 16.1902 7.30585L18.4259 9.41243H5.57545L7.81078 7.30585ZM3.33858 11.9433C3.33858 11.3648 3.80428 10.8953 4.37927 10.8953C4.95389 10.8953 6.83167 11.9669 6.83167 12.5454C6.83167 13.1238 4.95389 12.9899 4.37927 12.9899C3.80428 12.9899 3.33858 12.5222 3.33858 11.9433ZM6.4595 15.7696H6.06308L4.8873 15.7714C4.56093 15.6727 4.33078 15.5574 4.16798 15.4336C4.09435 15.3784 4.02883 15.3137 3.97323 15.2412C3.92715 15.1821 3.89032 15.1167 3.86393 15.0471C3.71768 14.6452 4.0198 14.2759 4.0198 14.2759H6.02652L7.36433 15.7688L6.4595 15.7696ZM14.8859 15.7703H9.11511C8.82614 15.7702 8.54902 15.6586 8.34465 15.46C8.14027 15.2614 8.02536 14.992 8.02516 14.711H15.9758C15.9757 14.992 15.8608 15.2614 15.6564 15.4601C15.4521 15.6587 15.1749 15.7703 14.8859 15.7703ZM15.1391 13.9882H8.86187C8.20758 13.9882 7.67646 13.2039 7.67646 12.2367H16.3245C16.3245 13.2043 15.7934 13.9882 15.1391 13.9882ZM20.1374 15.0478C20.1108 15.1173 20.0739 15.1826 20.0277 15.2416C19.9724 15.3142 19.9068 15.379 19.833 15.4339C19.6706 15.5578 19.44 15.6738 19.1137 15.7718L17.9379 15.7699H16.6359L17.9745 14.277H19.9808C19.9808 14.2766 20.2833 14.6452 20.1374 15.0478ZM19.6217 12.9899C19.0475 12.9899 17.1697 13.1231 17.1697 12.5454C17.1697 11.9676 19.0475 10.8953 19.6217 10.8953C20.1967 10.8953 20.6624 11.3648 20.6624 11.9433C20.6624 12.5214 20.1967 12.9899 19.6217 12.9899Z" fill="#1A1A1A"/>
              </svg>
              <span class="ml-2">কার যুক্ত করুন</span>
          </div>

				<p
					class="cursor-pointer flex capitalize px-4 py-2 hover:bg-gray-100"
					@click="
						logOut();
						$emit('onClickAccountDropdown');
					"
				>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_1200_3303)">
                    <mask id="mask0_1200_3303" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                        <path d="M0 0H24V24H0V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_1200_3303)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.06318 6.54737C8.06318 4.95579 8.06318 4.16 8.3612 3.55179C8.62332 3.01704 9.04158 2.58227 9.55602 2.30979C10.1411 2 10.9067 2 12.4378 2H14.6251C16.1562 2 16.9218 2 17.5069 2.30979C18.0214 2.58227 18.4396 3.01704 18.7017 3.55179C18.9998 4.16 18.9998 4.95579 18.9998 6.54737V15.4526C18.9998 17.0442 18.9998 17.84 18.7017 18.4482C18.4396 18.983 18.0214 19.4177 17.5069 19.6902C16.9218 20 16.1562 20 14.6251 20H12.4378C10.9067 20 10.1411 20 9.55602 19.6902C9.04158 19.4177 8.62332 18.983 8.3612 18.4482C8.06318 17.84 8.06318 17.0442 8.06318 15.4526V14.0789H11.7087C12.4943 14.0789 13.2477 13.7546 13.8031 13.1771C14.3586 12.5997 14.6707 11.8166 14.6707 11C14.6707 10.1834 14.3586 9.40027 13.8031 8.82286C13.2477 8.24544 12.4943 7.92105 11.7087 7.92105H8.06318V6.54737ZM5.679 8.99537C5.7848 8.88539 5.86873 8.75483 5.92599 8.61113C5.98325 8.46744 6.01272 8.31343 6.01272 8.1579C6.01272 8.00236 5.98325 7.84835 5.92599 7.70466C5.86873 7.56096 5.7848 7.4304 5.679 7.32042C5.5732 7.21044 5.4476 7.1232 5.30936 7.06368C5.17113 7.00416 5.02297 6.97353 4.87334 6.97353C4.72372 6.97353 4.57556 7.00416 4.43732 7.06368C4.29908 7.1232 4.17348 7.21044 4.06768 7.32042L1.33353 10.1625C1.22772 10.2725 1.14377 10.4031 1.0865 10.5468C1.02923 10.6904 0.999756 10.8445 0.999756 11C0.999756 11.1555 1.02923 11.3096 1.0865 11.4532C1.14377 11.5969 1.22772 11.7275 1.33353 11.8375L4.06768 14.6796C4.28135 14.9017 4.57116 15.0265 4.87334 15.0265C5.17552 15.0265 5.46533 14.9017 5.679 14.6796C5.89268 14.4575 6.01272 14.1562 6.01272 13.8421C6.01272 13.528 5.89268 13.2267 5.679 13.0046L4.88975 12.1842H11.7087C12.0108 12.1842 12.3006 12.0594 12.5143 11.8374C12.7279 11.6153 12.8479 11.3141 12.8479 11C12.8479 10.6859 12.7279 10.3847 12.5143 10.1626C12.3006 9.94055 12.0108 9.81579 11.7087 9.81579H4.88975L5.679 8.99537Z" fill="#1A1A1A"/>
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_1200_3303">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
					<span
						class="text-sm ml-2 text-gray-700 hover:text-gray-900"
						v-if="!isLoggingOut"
						>লগআউট</span
					>
					<span class="text-sm ml-2 text-gray-700 hover:text-gray-900" v-else
						>লগআউট হচ্ছে</span
					>
				</p>
			</div>
		</div>
	</div>
	<div
		v-if="showDropdown"
		@click="showDropdown = !showDropdown"
		class="fixed inset-0 bg-black z-40 opacity-0"
	></div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { links } from "@/data/loggedinuserlinks";
import RoundImage from "@/components/atom/RoundImage";
import Form from "@/services/form";
import {clearDeviceInterests} from "@/services/clearDeviceInterests";
export default {
	name: "AccountDropdown",
	emits: ["onClickAccountDropdown"],
	components: {
		RoundImage,
	},

	data() {
		return {
			isLoggingOut: false,
			form: new Form(),
			showDropdown: false,
			links,
		};
	},

	props: {
		userType: { required: false },
	},

	computed: {
		...mapGetters({
			user: "user/getUser",
		}),
	},

	methods: {
		...mapMutations({
			setUserInfo: "user/setLoggedInUser",
		}),

		nevigate() {
			this.showDropdown = false;
		},

		async logOut() {
			localStorage.removeItem("trip_auth_user");
			localStorage.removeItem("token");
			localStorage.removeItem("imp_token");
            clearDeviceInterests();
			this.isLoggingOut = true;
			try {
				await this.form.post("auth/logout");
			} catch (err) {
				if (err.response) {
				}
			} finally {
				this.setUserInfo(null);
				this.$router.push("/signup");
			}
		},
	}, //end of methods

	created() {
		this.setUserInfo();
	},
};
</script>

<style>
svg.opened {
	transform: rotate(180deg);
	transition: all 300ms ease-in-out;
}
svg.closed {
	transition: all 300ms ease-in-out;
}
</style>
